export const clearState = (stateName) => ({
    type: stateName
});